module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e2128"
    }
  }, [_c('span', [_vm._v("contents")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2178"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Text/Morg_9781550924589_epub_c6_r1#d7e32410",
      "id": "d14e147"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2228"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Text/Morg_9781550924589_epub_c7_r1#d7e38012",
      "id": "d14e150"
    }
  }, [_vm._v("Preface to the New Edition")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2278"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Text/Morg_9781550924589_epub_c8_r1#d7e76416",
      "id": "d14e153"
    }
  }, [_vm._v("Introduction to the 1990 Edition")]), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2328"
    }
  }, [_c('span', {
    staticClass: "sgc-1"
  }, [_vm._v("PART I : Ingredients")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2388"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Text/Morg_9781550924589_epub_c9_r1#d7e139422",
      "id": "d14e161"
    }
  }, [_vm._v("Produce List")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2438"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Morg_9781550924589_epub_c29_r1#d7e575163",
      "id": "d14e164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Ingredients Common to These Recipes")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2488"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Morg_9781550924589_epub_c30.1_r1#d7e644969",
      "id": "d14e167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Note on Urban Compost")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2538"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Morg_9781550924589_epub_c30.2_r1#d7e671271",
      "id": "d14e170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gluten-free Recipes")]), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2588"
    }
  }, [_c('span', {
    staticClass: "sgc-1"
  }, [_vm._v("PART II : Recipes")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2638"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Morg_9781550924589_epub_c31_r1#d7e676272",
      "id": "d14e178",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soups")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2698"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Morg_9781550924589_epub_c59_r1#d7e10128100",
      "id": "d14e182",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salads")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2748"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Morg_9781550924589_epub_c79_r1#d7e12277122",
      "id": "d14e185",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Main Dishes")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2798"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Morg_9781550924589_epub_c129_r1#d7e19187174",
      "id": "d14e188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Side Dishes")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2848"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Morg_9781550924589_epub_c203_r1#d7e27096248",
      "id": "d14e191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sauces")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2898"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Morg_9781550924589_epub_c213_r1#d7e28087258",
      "id": "d14e194",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Desserts & Baked Goods")]), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2948"
    }
  }, [_c('span', {
    staticClass: "sgc-1"
  }, [_vm._v("PART III: Ideas and Resources")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e3008"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Morg_9781550924589_epub_c246_r1#d7e32213292",
      "id": "d14e202",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Menus")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e3058"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Morg_9781550924589_epub_c252_r1#d7e32664298",
      "id": "d14e205",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resources")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e3158"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Morg_9781550924589_epub_c256_r1#d7e33701320",
      "id": "d14e208",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-325dff08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Morg_9781550924589_epub_c5_r1.vue
// module id = 72
// module chunks = 0